module.exports = __webpack_public_path__ + "c9a3be7d601e1cb66e4ac85894553af6.pdf";